import { useStore } from 'zustand';

import { FirebaseState, firebaseStore } from 'store/firebaseStore';

export const useFirebaseStore = <T>(selector?: (state: FirebaseState) => T) => {
  return useStore(firebaseStore, selector!);
};
